import React, { FC } from 'react';
import { Box, Text, Button, SectionHelper } from '@wix/design-system';
import BriefPromoMobileIcon from '@components/Images/brief-promo/brief-promo-card-mobile-icon.gif';
import { briefPromoCardDataHooks } from './BriefPromoCard.dataHooks';
import { useBriefPromoCard } from './useBriefPromoCard';

const BriefPromoCardMobile: FC = () => {
  const { t, matchURL, handleCtaClick } = useBriefPromoCard();

  return (
    <SectionHelper
      fullWidth
      dataHook={briefPromoCardDataHooks.boxContainer()}
      appearance="standard"
    >
      <Box direction="horizontal" gap="18px" verticalAlign="top">
        <img
          src={BriefPromoMobileIcon.src}
          width={72}
          height={103}
          alt=""
          data-hook={briefPromoCardDataHooks.gif()}
        />
        <Box direction="vertical" verticalAlign="middle" gap="6px">
          <Text size="small" weight="bold">
            {t('explore-page.brief-promo-card.title')}
          </Text>
          <Text size="small">
            {t('explore-page.brief-promo-card.subtitle')}
          </Text>
          <Box paddingTop="6px">
            <Button
              skin="standard"
              as="a"
              size="small"
              href={matchURL}
              target="_blank"
              dataHook={briefPromoCardDataHooks.cta()}
              onClick={handleCtaClick}
            >
              {t('explore-page.brief-promo-card.cta')}
            </Button>
          </Box>
        </Box>
      </Box>
    </SectionHelper>
  );
};

export default BriefPromoCardMobile;
